import styled from 'styled-components'

export const StyledStart = styled.div`
  padding: 25px 0 200px 0;
  min-height: 100vh;
`
